import Vue from 'vue'
import store from './store/index';
import axios from '@/utils/axios';

const Api = {
  get(path, parameters) {
    return axios.get(path, {params: parameters})
  },
  post(path, parameters) {
    return axios.post(path, parameters)
  },
  fetch(chartType, parameters) {
    const parameter = {
      ...store.state.filter,
      chart_type: chartType,
      ...parameters
    }
    return axios.post("v3/statistics", parameter)
  },
  award_fetch(chartType, userId, parameters = {}) {
    const parameter = {
      chart_type: chartType,
      ...parameters
    }
    return axios.get(`award/${userId}/chart`, { params: parameter })
  },
  getJobApplications() {
    const parameter = {
      ...store.state.filter,
    }
    const params = { from: parameter.from, to: parameter.to }
    return axios.get("v2/job_applications", { params });
  },
  saveJobApplications(months) {
    return axios.post("v2/job_applications", { months, from: store.state.filter.from, to: store.state.filter.to });
  },
  syncJobApplications(from, to) {
    return axios.post("v2/job_applications/sync", { from, to });
  }
}

export default Api
